/**
 * Generates a favicon programmatically using Canvas.
 * Design: "TM" monogram (Theresa Mühlbacher) – olive-900 background, gold-300 text.
 */
export function generateFavicon(): void {
  const canvas = document.createElement('canvas');
  const size = 64;
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  // Background circle – olive-900 (#2F3520)
  ctx.fillStyle = '#2F3520';
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
  ctx.fill();

  // Gold ring border – gold-300 (#D5C479)
  ctx.strokeStyle = '#D5C479';
  ctx.lineWidth = 3;
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2 - 3, 0, Math.PI * 2);
  ctx.stroke();

  // "TM" monogram – gold-300
  ctx.fillStyle = '#D5C479';
  ctx.font = 'bold 24px Georgia, serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('TM', size / 2, size / 2 + 1);

  // Replace existing favicon link or create a new one
  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.type = 'image/png';
  link.href = canvas.toDataURL('image/png');
}
